const FAVICON_ID = 'favicon';

/**
 * Keeps the favicon in sync with the OS color scheme by swapping the `<link id="favicon">` href
 * via `matchMedia`, since browsers don't reliably react to `media="(prefers-color-scheme: ...)"`
 * on the <link> itself. See configs/html-inject/head.ejs.
 */
export function watchFaviconColorScheme() {
  const favicon = document.getElementById(FAVICON_ID);
  if (!(favicon instanceof HTMLLinkElement)) {
    return;
  }

  const { hrefDark, hrefLight } = favicon.dataset;
  if (!hrefDark || !hrefLight) {
    return;
  }

  const query = window.matchMedia('(prefers-color-scheme: dark)');
  const applyScheme = (isDark: boolean) => {
    favicon.href = isDark ? hrefDark : hrefLight;
  };

  applyScheme(query.matches);
  query.addEventListener('change', event => applyScheme(event.matches));
}
